import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Ready() {
    return (
        <OnboardingBody title='All set! Scheduler is ready to go'>
            <p>
                Your scheduler is currently using Nutshell to create new events and check for
                conflicts.
            </p>
            <p>
                You have the option to change this at any time, but it will affect the availability
                for all active meetings.
            </p>
            <p>Happy scheduling!</p>
        </OnboardingBody>
    );
}
